import React from 'react';
import { useTheme } from '@mui/material';
export default function SVGTrackLabel(_ref) {
  var trackLabels = _ref.trackLabels,
    trackName = _ref.trackName,
    fontSize = _ref.fontSize,
    trackLabelOffset = _ref.trackLabelOffset,
    x = _ref.x;
  var theme = useTheme();
  var fill = theme.palette.text.primary;
  var xoff = trackLabels === 'overlay' ? 5 : 0;
  return trackLabels !== 'none' ? React.createElement("g", null, trackLabels === 'left' ? React.createElement("text", {
    x: trackLabelOffset - 40,
    y: 20,
    fill: fill,
    fontSize: fontSize,
    dominantBaseline: "hanging",
    textAnchor: "end"
  }, trackName) : React.createElement("text", {
    x: x + xoff,
    fill: fill,
    fontSize: fontSize,
    dominantBaseline: "hanging"
  }, trackName)) : null;
}